import { navigateToExternalUrl } from '@rhg/utils/browser';
import { routes } from '@rhg/utils/routes';
import { isAxiosError } from 'axios';

let logoutRedirectSuppressed = false;

/**
 * Account deletion ends the session on purpose, so the 401s and the Auth0
 * re-login that follow must not pull the user off the deletion confirmation
 * before they dismiss it.
 */
export const setLogoutRedirectSuppressed = (suppressed: boolean): void => {
    logoutRedirectSuppressed = suppressed;
};

export const isLogoutRedirectSuppressed = (): boolean =>
    logoutRedirectSuppressed;

/**
 * 👻 A 401 means the account bearer is dead (e.g. it expired while the tab
 * lay buried in the background — EVE-5971). Per-hook 401 handling cannot
 * perform this exorcism: with a dead bearer the account bootstrap fails
 * first, account-gated queries (and their error handlers) are trapped in
 * limbo, never enabled, and the app sits on skeletons forever 💀🪦 — a page
 * that loads for all eternity. Handling it at the axios layer catches every
 * 401 from any query, mutation, or one-off call and sends the user to the
 * logout page, which lays the session to rest properly.
 */
export const redirectToLogoutIfUnauthorized = (error: unknown): void => {
    if (!isAxiosError(error) || error.response?.status !== 401) return;
    if (typeof window === 'undefined') return;
    if (isLogoutRedirectSuppressed()) return;
    // Already on the logout page — let it finish instead of looping.
    if (window.location.pathname === routes.logout) return;
    navigateToExternalUrl(routes.logout);
};
